<template>
    <div class="dialog">
        <el-dialog :visible.sync="isShow" :close-on-click-modal="false" :modal="isModel" :show-close="closeBtn" :close-on-press-escape="false" :width="dialogWidth" :before-close="closeCallBack" :fullscreen="isFullscreen">
            <template slot="title">
                <div class="title">{{title}}</div>
            </template>
            <el-scrollbar :style="{height:[isFullscreen ? devScrollH : scrollHeight]}">
                <slot name="froms"></slot>
                <!-- <el-form :model="form" label-width="100px">
                    <el-form-item label="上级机构">
                        <el-col :span="6">
                            <el-select v-model="form.value" placeholder="请选择活动区域">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-col>
                    </el-form-item>

                    <el-form-item label="机构名称">
                        <el-col :span="6">
                            <el-input v-model="form.value" autocomplete="off"></el-input>
                        </el-col>
                    </el-form-item>
                </el-form> -->
            </el-scrollbar>
            <div slot="footer" class="dialog-footer" v-if="cancelBtn || okBtn">
                <el-button @click="cancel" v-if="cancelBtn">{{cancelBtnText}}</el-button>
                <el-button type="primary" @click="ok" v-if="okBtn">{{okBtnText}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        isShow: false, // 是否显示dialog
        title: { // 标题
            type: String,
            default: '提示'
        },
        scrollHeight: { // body滚动区域可视高度
            type: String,
            default: '300px'
        },
        dialogWidth: { // 弹框宽度
            type: String,
            default: '50%'
        },
        cancelBtnText: { // 取消按钮文案
            type: String,
            default: '取 消'
        },
        okBtnText: { // 确定按钮文案
            type: String,
            default: '确 定'
        },
        cancelBtn: { // 是否显示取消按钮
            type: Boolean,
            default: true
        },
        okBtn: { // 是否显示确定按钮
            type: Boolean,
            default: true
        },
        closeBtn: { // 是否右上角关闭按钮
            type: Boolean,
            default: true
        },
        isFullscreen: Boolean,
        isModel: {
          type: Boolean,
          default: true
        }
    },
    components: {},
    computed: {},
    watch: {},
    data() {
        return {
            devScrollH: ''
        }
    },
    created() {
        // console.log(this.isFullscreen)
        this.SetScrollHeight();
    },
    methods: {
        cancel() { // 取消
            // this.isShow = false;
            this.$emit('cancel', '1');
        },
        ok() { // 确定回调
            // this.isShow = false;
            this.$emit('ok', '1');
        },
        closeCallBack() { // 弹窗关闭前回调
            this.$emit('closeCallBack', '1');
        },
        SetScrollHeight() {
            let appH = document.getElementById("app").offsetHeight - 200;
            if (this.isFullscreen) {
                if (!this.okBtn && !this.cancelBtn) {
                    appH = appH + 80;
                }
                this.devScrollH = appH + 'px';
            }
        }
    },
}
</script>

<style lang="less" scoped>
.title {
    color: #000;
    font-weight: bold;
    font-size: 20px;
    // padding-bottom: 20px;
    // border-bottom: 1px solid #a7a7a7;
}
.dialog /deep/ .el-scrollbar__wrap {
    overflow-x: hidden !important;
}
.dialog /deep/ .el-dialog__header {
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    background: #f3f3f3;
    border-bottom: 1px solid #e3e3e3;
}
.dialog-footer {
    text-align: center;
}
.dialog /deep/ .el-dialog__headerbtn {
  top: 15px;
  right: 15px;
}
.dialog /deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #000;
  font-size: 30px;
  line-height: 30px;
}
</style>
